<template>
    <div class="form-group mt-2">
        <label class="form-label" for="cluster_company">
            Виберiть з випадаючого списку Організацію
        </label>
        
        <div class="" v-if="draw_items.length > 0">
            <v-select
                v-model="active_company"
                id="cluster_company"
                class="imc_reasons"
                :reduce="item => item.company"
                label="company"
                :options="this.draw_items"
                :filterable="false"
            >
                <template slot="no-options">
                    Оберіть організацію
                </template>
                
                <template slot="option" slot-scope="option">
                    <div class="d-center">
                        <b>
                            {{ option.company }}
                        </b>
                        <div class="small">
                            USERS_IN: {{ option.count }}
                        </div>
                    </div>
                </template>
            </v-select>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select';
export default {
    name: "users_org_select",
    components : {
        vSelect
    },
    data() {
        return {
            is_load: false,
            items : [],
            current_item : null,
        }
    },
    
    props : {
        active_name : {
            type : String,
            default : "",
        },
    },
    
    created () {
        this.load_organizations();
    },
    
    methods : {
        async load_organizations() {
            this.items = [];
            await api.get('/hr/clusters').then(({data}) => {
                this.is_load = true;
                if(data.status === "operation_success") {
                    this.items = data.data;
                }
            }).catch(err => {
                EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name});
                this.is_load = false;
            });
        },
    },
    
    computed : {
        draw_items() {
            return this.items;
        },
        
        active_company : {
            get() {
                if(this.active_name.length > 0) {
                    return this.active_name;
                }
                return null;
            },
            set(new_id) {
                this.$emit('on_item_set',new_id);
            }
        },
    }
}
</script>



<style scoped>

</style>